export default async function init() {
  const popups = document.querySelectorAll('[data-js-module="popup"]');

  const initPopup = async () => {
    const { default: Popup } = await import(/* webpackChunkName: "popup" */ './popup.js');
    popups.forEach((popup) => new Popup(popup));
  };

  if (popups.length) initPopup();
}

init();
